export const resetPasswordContainer = "flex items-center justify-center min-h-screen bg-gray-200 dark:bg-gray-900 px-4 py-6";

export const formContainer = "flex flex-col justify-center w-full max-w-md p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800";

export const iconContainer = "flex justify-center items-center mb-5";

export const keyIcon = "w-12 h-12 text-blue-500 bg-blue-100 p-2 rounded-full";

export const titleContainer = "mb-5 sm:mb-8 text-center";

export const heading = "text-2xl font-semibold text-gray-800 dark:text-white";

export const formGroup = "flex flex-col gap-6";

export const inputContainer = "flex flex-col";

export const inputWrapper = "relative";

export const inputField = "w-full px-4 py-2 pr-10 border border-gray-300 rounded focus:outline-none focus:border-blue-500 transition";

export const inputFieldError = "w-full px-4 py-2 pr-10 border border-red-400 ring-2 ring-red-500/10 dark:border-red-400 dark:ring-2 dark:ring-red-500/10  rounded focus:outline-none focus:border-blue-500 transition";

export const successMessage = "text-green-500 text-sm";

export const buttonContainer = "mt-4";

export const loginButton = "w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 transition";

export const eyeIconBtn = "absolute inset-y-0 right-3 flex items-center text-gray-500 dark:text-gray-500";

export const requiredStar = "text-red-500";

export const errorText = "text-red-500 text-sm mt-1";
export const backButton =
  "mt-3 text-gray-500 hover:underline w-full";